/*
 * @Author: your name
 * @Date: 2020-04-22 10:08:34
 * @LastEditTime: 2020-04-29 18:29:18
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \frontend\modules\@cloudpivot\form\src\components\Dropdown\schema.ts
 */
import { selectControlOptions } from "../../../../form/component-schema";
import { DataType } from "../../../../form/typings";
import i18n from "../../../i18n";
export default {
    $id: "dropdown",
    type: DataType.Object,
    $ref: selectControlOptions.$id,
    properties: {
        options: {
            type: DataType.String,
            title: i18n.t('dataitem.Options').toString(),
            default: "",
        },
        widgetType: {
            type: DataType.Number,
            title: i18n.t('dataitem.ControlType').toString(),
        },
        dataItemType: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemType').toString(),
        },
        displayEmpty: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.ShowEmptyOptions').toString(),
            default: true,
        },
        emptyValue: {
            type: DataType.String,
            title: i18n.t('dataitem.EmptyOptionsValue').toString(),
            default: i18n.t('dataitem.SelectPlaceholder').toString(),
        },
        multi: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.Multi').toString(),
            default: false,
        },
        dataLinkage: {
            type: DataType.String,
            title: i18n.t('dataitem.DataLinkage').toString(),
        },
        labelVisible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.LabelVisible').toString(),
            default: true,
        },
        readonlyCondition: {
            type: DataType.String,
            title: i18n.t('dataitem.ReadonlyConditions').toString(),
        },
    },
};
